import { MatSnackBar } from '@angular/material/snack-bar';

export class HandlerService {
    private typeMsg = {
        success_msg: 'success__msg',
        error_msg: 'error__msg',
        info_msg: 'info__msg'
    };

    constructor(private _snackBar: MatSnackBar) {}

    private handler(msg: string, duration: number, customClass: string = '') {
        this._snackBar.open(msg, 'Закрыть', {
            duration: duration,
            verticalPosition: 'top',
            panelClass: customClass
        });
    }

    successMsg(msg: string, duration: number = 5000) {
        this.handler(msg, duration, this.typeMsg.success_msg);
    }

    errorMsg(msg: string, duration: number = 5000) {
        this.handler(msg, duration, this.typeMsg.error_msg);
    }

    infoMsg(msg: string, duration: number = 5000) {
        this.handler(msg, duration, this.typeMsg.info_msg);
    }

    checkErrors(resp: any): void {
        if (resp && resp.error) {
            this.errorMsg(resp.error);
        }
    }
}
